import "bootstrap/dist/js/bootstrap";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";

import "./assets/css/icomoon.css";
import "./assets/css/slick.css";
import "./assets/css/animate.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "./assets/vendors/themify-icons/css/themify-icons.css";
import TagManager from "react-gtm-module";
import AllRoutes from "./routes/AllRoutes";
import { Helmet } from 'react-helmet';
import { useEffect, useState } from "react";
//import ReactGA from "react-ga";

// require('dotenv').config()

// import $ from 'jquery';
const tagManagerArgs = {
  gtmId: "GTM-P95V8ST",
};

// TagManager.initialize(tagManagerArgs);
// let TRACKING_ID = "G-6XV1W8B1TD";
// ReactGA.initialize(TRACKING_ID);

function App() {
  const [isProdUrl, setIsProdUrl] = useState(false)
  // window.dataLayer.push({
  //   event: "pageview",
  // });
  //let isProdUrl = window.location.hostname === "www.rightcause.net" ? true : false;


  useEffect(() => {
    
    let check_Url = window.location.hostname === "www.rightcause.net" ? true : false;
    setIsProdUrl(check_Url);

    // Initialize Google Tag Manager after 5 Seconds
    let timer = setTimeout( function() {
      TagManager.initialize(tagManagerArgs);

      // Page Tracking: To signal to DTM that we would like to track a new page we can use an event like this.
      window.dataLayer.push({
        event: "pageview",
      });
    }, 5000 );

    // Clear the timer after initializing Google Tag Manager
    return () => clearTimeout( timer );
  }, []);

  console.log('isProdUrl: ', isProdUrl);

  // useEffect(() => {
  //   //ReactGA.pageview(window.location.pathname);
  // }, []);

  // $(document).ready(function () {
  //   $(".nav-link").on('click', function (event) {

  //     if (this.hash !== "") {

  //       event.preventDefault();

  //       var hash = this.hash;

  //       $('html, body').animate({
  //         scrollTop: $(hash).offset().top
  //       }, 700, function () {
  //         window.location.hash = hash;
  //       });
  //     }
  //   });

  // $(document).ready(function () {
  // $(".nav-link").on('click', function (event) {

  //   if (this.hash !== "") {

  //     event.preventDefault();

  //     var hash = this.hash;

  //     $('html, body').animate({
  //       scrollTop: $(hash).offset().top
  //     }, 700, function () {
  //       window.location.hash = "/";
  //     });
  //   }
  // });
  //  });
 useEffect(() => {
  AOS.init();
 },[])
  return (
    <div className="App">
      {isProdUrl ? (
        <Helmet>
          <link rel="canonical" href="https://www.rightcause.net/" />
        </Helmet>
      ) : null}
      {/* <Home /> */}
      <AllRoutes />
    </div>
  );
}
export default App;
